import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal'
import {
  Button,
  Form,
  Input,
} from 'antd';
import Swal from 'sweetalert2';
import { useAdminClient } from "hooks/useAdminClient";

const AddImage = (params) => {
  const client = useAdminClient();
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [form] = Form.useForm();
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 6,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 14,
      },
    },
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setPreview(URL.createObjectURL(selectedFile));
  };

  const handleSubmit = async (e) => {
    try {
      if (!file) return alert("Please select a file.");
      const formData = new FormData();
      formData.append("img", file);
      await client.post("/be/api/v1/images/create", formData, { headers: { "Content-Type": "multipart/form-data", 
        "Authorization": `Bearer ${localStorage.getItem("authToken")}`, // Add Bearer prefix
      }});
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Add image success",
        showConfirmButton: false,
        timer: 1500
      });
      params.setShowModal(false);
      params.fetchData();
    } catch (error) {
      console.log(error);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Add image error",
        showConfirmButton: false,
        timer: 1500
      });
    }
  }

	return (
    <div id='add-image'>
      <Modal
        show={params.showModal}
        onHide={params.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Add Image
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form
            {...formItemLayout}
            form={form}
            onFinish={handleSubmit}
          >
            <Form.Item
              label="Input Banner Image"
              name="InputBannerImg"
              rules={[
                {
                  required: true,
                  message: 'Please input!',
                },
              ]}
            >
              <Input type="file" accept="image/*" onChange={handleFileChange}/>
              {preview && <img src={preview} alt="Preview" width="200" />}
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 6,
                span: 16,
              }}
            >
              <Button
                style={{maxWidth: "100px"}}
                type="primary"
                htmlType="submit"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
	);
};

export default AddImage